import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { requestReports } from "actions";

import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import MessageBox from "components/MessageBox";
import { AgentReports } from "components/SaleReports";

import { userTypes } from "constants/users";

import toast from "lib/toast";

import {
  currentSaleSelector,
  getIsOnline,
  getReportFavourites,
  getSaleLotsBySale,
  prepareAgentReportData,
  selectIsUserOfType,
} from "selectors";

import { isLoadingSaleReports } from "selectors/loading";

const selectIsNonBusinessReportUser = selectIsUserOfType([
  userTypes.LIVESTOCK_AGENT,
  userTypes.SALEYARD_ADMIN,
  userTypes.SCALE_OPERATOR,
]);

const selectShowNLISActions = selectIsUserOfType([
  userTypes.SALEYARD_ADMIN,
  userTypes.SCALE_OPERATOR,
]);

const ReportComponent = () => {
  const dispatch = useDispatch();
  const sale = useSelector(currentSaleSelector);
  const saleId = sale.livestocksale_id;
  const saleyard = sale.saleyard_name;

  const isFetching = useSelector(isLoadingSaleReports);
  const saleLots = useSelector(getSaleLotsBySale);
  const isNonBusinessReportUser = useSelector(selectIsNonBusinessReportUser);
  const showNLISActions = useSelector(selectShowNLISActions);
  const agentReportData = useSelector(prepareAgentReportData);
  const reportFavourites = useSelector(getReportFavourites);

  useEffect(() => {
    dispatch(requestReports(saleyard, saleId));
  }, [dispatch, saleyard, saleId]);

  if (isFetching) {
    return (
      <MessageBox>
        <LoadingSpinner size={24} subjectName="" />
      </MessageBox>
    );
  }

  if (isNonBusinessReportUser) {
    if (!isFetching && saleLots.length === 0) {
      toast.info(
        "More reports will become available once sale lots have been created.",
      );
    }
    const { filters, reportData } = agentReportData;
    return (
      <AgentReports
        reportData={reportData}
        filters={filters}
        showNLISActions={showNLISActions}
        reportFavourites={reportFavourites}
      />
    );
  } else {
    return <MessageBox>No Access</MessageBox>;
  }
};

const Reports = React.memo(() => {
  const isOnline = useSelector(getIsOnline);
  if (!isOnline) {
    return <MessageBox>Reports are not available offline.</MessageBox>;
  } else {
    return <ReportComponent />;
  }
});

export default Reports;
